import React from "react";
import { KButton, KButtonProps } from "@kyburz/kdesign-system";
import clsx from "clsx";
import Header from "../header/Header";
import "./BaseLayout.css";
import { TabInterface } from "../../interfaces/tab-interface";

interface BaseLayoutProps {
  title: string;
  children: React.ReactNode;
  handleArrowClick?: Function | any;
  tabs?: TabInterface[] | undefined;
  handleTabChange?: Function | any;
  activeTab?: string | number | undefined;
  actionButtons?: React.PropsWithChildren<KButtonProps>[];
  mainClassname?: string;
}

const BaseLayout: React.FC<BaseLayoutProps> = ({
  title,
  children,
  handleArrowClick = undefined,
  tabs = undefined,
  handleTabChange = undefined,
  activeTab = undefined,
  actionButtons,
  mainClassname,
}: BaseLayoutProps) => (
  <div className="baselayout__background">
    <div className="baselayout__header">
      <Header
        title={title}
        handleArrowClick={handleArrowClick}
        tabs={tabs}
        handleTabChange={handleTabChange}
        activeTab={activeTab}
      />
    </div>
    <main className={clsx("baselayout__main", mainClassname)}>
      {actionButtons && (
        <section className="baselayout__buttons">
          {actionButtons.map((button) => (
            <KButton key={button.children?.toString()} {...button} />
          ))}
        </section>
      )}

      {children}
    </main>
  </div>
);

export default BaseLayout;
